import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path d='M14 6L8 12L14 18' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
);

export const ArrowIcon = styled(Icon)({});
